import 'edge/quoteandbind/common/models/Submission';

export default ['JsonRPCService', 'qnb.endpointConfig', 'qnb.xCenterRouteConfig', function (JsonRPCService, endpointConfig, xCenterRouteConfig) {

    var endpoint = endpointConfig.bopCoverablesEndpoint;
    var xCenterRoute = xCenterRouteConfig;

    return {
        addCPPLocation: function addCPPLocation(quoteID, bopLocation, sessionUUID) {
            return JsonRPCService.send(xCenterRoute, endpoint, 'addLocation', [quoteID, bopLocation, sessionUUID]);
        },
        updateCPPLocation: function updateCPPLocation(quoteID, bopLocation, sessionUUID) {
            return JsonRPCService.send(xCenterRoute, endpoint, 'updateLocation', [quoteID, bopLocation, sessionUUID]);
        },
        removeCPPLocation: function removeCPPLocation(quoteID, bopLocation, sessionUUID) {
            return JsonRPCService.send(xCenterRoute, endpoint, 'removeLocation', [quoteID, bopLocation, sessionUUID]);
        },
        addCPPBuilding: function addCPPBuilding(quoteID, bopLocationId, bopBuilding, sessionUUID) {
            return JsonRPCService.send(xCenterRoute, endpoint, 'addBuilding', [quoteID, bopLocationId, bopBuilding, sessionUUID]);
        },
        updateCPPBuilding: function updateCPPBuilding(quoteID, bopLocationId, bopBuilding, sessionUUID) {
            return JsonRPCService.send(xCenterRoute, endpoint, 'updateBuilding', [quoteID, bopLocationId, bopBuilding, sessionUUID]);
        },
        removeCPPBuilding: function removeCPPBuilding(quoteID, bopLocationId, bopBuildingId, sessionUUID) {
            return JsonRPCService.send(xCenterRoute, endpoint, 'removeBuilding', [quoteID, bopLocationId, bopBuildingId, sessionUUID]);
        },
        updateCPPBuildingCoverages: function updateCPPBuildingCoverages(quoteID, bopLocationId, bopBuilding, sessionUUID) {
            return JsonRPCService.send(xCenterRoute, endpoint, 'updateBuildingCoverages', [quoteID, bopLocationId, bopBuilding, sessionUUID]);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/ama/cpp/services/CPPCoverablesService.js
// module id = 828
// module chunks = 0